import { useGetRequest } from 'hooks/utils/useGetRequest';

const useGetGroup = (groupId: string) => {
  const path = `v1/groups/${groupId}`;

  const [{ data, error, loading }] = useGetRequest<any>({
    path, useRouteIssuer: true
  });
  return {
    group: data,
    isLoading: loading,
    isError: error,
  };
};

export default useGetGroup;
